export default __webpack_public_path__ + "static/media/dietary-lifestyle-in-germany-france-netherlands.1fd83935.png";